export function getEmptyValues(data) {
  return Object.keys(data).reduce((acc, key) => {
    if (data[key] === '') {
      acc[key] = 'Required';
    }
    return acc;
  }, {});
}